'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CurrencyIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CurrencyIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Currency-Pound--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Currency Pound Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="m3.504 12.5 15 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M20.5 6a5.5 5.5 0 0 0 -11 0v12.5a5 5 0 0 1 -5 5h16"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

CurrencyIcon.propTypes = {
  sx: PropTypes.object
}
